import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EllipsisVertical, Pencil, Trash } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { TableCell, TableRow } from '@/components/ui/table';
import EditRegionDialog from './EditRegionDialog';
import DeleteRegionDialog from './DeleteRegionDialog';

const RegionRow = ({ region }) => {
  const navigate = useNavigate();
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  return (
    <>
      <TableRow
        onClick={() => navigate(`/region/${region.id}`)}
        className="cursor-pointer"
      >
        <TableCell className="py-2">{region.name}</TableCell>
        <TableCell className="py-2">{region.timeZone}</TableCell>
        <TableCell className="text-right py-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
              <Button variant="icon" size="icon" aria-label="Open menu">
                <EllipsisVertical size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
              <DropdownMenuLabel>{region.name}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => setIsEditDialogOpen(true)}>
                <Pencil />
                Edit Region
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="text-destructive"
                onClick={() => setIsDeleteDialogOpen(true)}
              >
                <Trash />
                Delete Region
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
      {isEditDialogOpen && (
        <EditRegionDialog region={region} setOpen={setIsEditDialogOpen} />
      )}
      {isDeleteDialogOpen && (
        <DeleteRegionDialog region={region} setOpen={setIsDeleteDialogOpen} />
      )}
    </>
  );
};

export default RegionRow;
